import { msg } from '@lingui/macro';
import { IconListDetails } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productMasterListImport',
  status: 'active',
  category: 'master-list',
  popularity: 2,
  icon: IconListDetails,
  title: msg`Master list`,
  shortTitle: msg`Master list for suppliers`,
  whenToUse: msg`The products you have in your portfolio and want your suppliers to enter information for.`,
  outputDescription: msg`Creates or updates a master list of products that suppliers fill in.`,
  intents: [
    'Send a master list to suppliers',
    'Collect supplier data via master list',
    'Distribute a fill-in catalogue to suppliers',
  ],
  keywords: [
    'master list',
    'supplier',
    'collect',
    'data entry',
    'distribute',
    'request',
    'fill-in',
  ],
  synonyms: ['supplier catalogue', 'data collection list'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Producer', 'Product name', 'Vintage', 'SKU'],
    requiredColumns: ['Producer', 'Product name'],
  },
};

export default descriptor;
